<template>
  <div
    class="LKMunMehCardHeader"
    :style="`cursor: ${actionless ? 'default' : 'pointer'};`"
    @click="actionless ? null : $emit('input', !value)"
  >
    <div class="LKMunMehCardHeader__item">
      <div
        class="LKMunMehCardHeader__date"
        v-text="formattedDate"
      />
    </div>

    <div class="LKMunMehCardHeader__item">
      <div
        class="LKMunMehCardHeader__id"
        v-text="`# ${id}`"
      />
    </div>

    <div class="LKMunMehCardHeader__spacer" />

    <div
      v-if="!actionless"
      class="LKMunMehCardHeader__action"
      v-text="'Действия:'"
    />

    <div v-if="!actionless" class="LKMunMehCardHeader__item">
      <router-link
        :to="linkTo"
        class="LKMunMehCardHeader__link"
        @click.native.stop
      >
        <IconLink
          borderless
          tooltip="Открыть в текущей вкладке"
          class="LKMunMehCardHeader__link-icon"
        />
      </router-link>
    </div>

    <div v-if="!actionless" class="LKMunMehCardHeader__item">
      <IconToggle
        :active="value"
        :loading="loading"
        class="LKMunMehCardHeader__link label__link"
      />
    </div>
  </div>
</template>

<script>
import { dateFormatterIgnoreTz } from '@/helpers/dateFormatter'
import { LK_MUN_MEH_ROUTES } from '@/views/LKMunMeh/utils'

import IconLink from '@/components/lk/icons/LKIconLink.vue'
import IconToggle from '@/components/lk/icons/LKIconToggle.vue'

const DATE_FORMAT = 'D MMM YYYY (dddd)'

export default {
  name: 'LKMunMehCardHeader',
  components: {
    IconLink,
    IconToggle,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    actionless: Boolean,
    loading: Boolean,
  },
  computed: {
    formattedDate() {
      return dateFormatterIgnoreTz(this.date, DATE_FORMAT)
    },
    linkTo() {
      return {
        name: LK_MUN_MEH_ROUTES.VIEW,
        params: {
          id: this.id,
        },
      }
    },
  },
}
</script>

<style lang="scss">
@import "~@/assets/scss/components/Card/_BaseCardHeader.scss";

.LKMunMehCardHeader {
  @include _BaseCardHeader;
}
</style>
